import { Event } from "../../../../base/common/events";
import { IStartup } from "../../../../base/common/lifecycle";
import { createDecorator } from "../../../../platform/instantiation/common/registry";
import { LogLevel } from "../../../../platform/log/common/log";


export const IUserConfiguration = createDecorator<IUserConfiguration>('userConfiguration');

export interface UserConfigurationChangeEvent {

}

export interface IUserConfiguration extends IStartup {

    readonly onDidChange: Event<UserConfigurationChangeEvent>;

    get canChangeLogLevel(): boolean;
    logLevel: LogLevel;
    get availableLogLevels(): Readonly<Record<LogLevel, string>>;

    theme: string;
    uiLayout: "default" | "minimal";

    hierarchyFilterInactive: boolean;
    richTooltip: boolean;
    webglPicking: boolean;
    propertyAutoRefresh: boolean;
    showSupportButton: boolean;

    setPanelVisible(panel: string, show: boolean): void;
    isPanelVisible(panel: string, fallbackValue?: boolean): boolean;

    setPanelCollapsed(panel: string, collapsed: boolean): void;
    isPanelCollapsed(panel: string, fallbackValue?: boolean): boolean;

    readAiApiKey(): Promise<string | null>;
    storeAiApiKey(key: string): Promise<void>;
}